import {
  plain,
  boolean,
  cm,
  kg,
  brachialPressure,
  percent,
  pressure,
  smoking,
  drinking,
  condition,
  snus,
  physicalActivity,
  highBloodPressure,
} from "./codecs";

export type CodecMap = typeof CODEC_MAP;

export type MetricName = keyof CodecMap;

export const CODEC_MAP = {
  "body.height": cm,
  "body.weight": kg,
  "body.waist": cm,
  "body.grip_strength.left": kg,
  "body.grip_strength.right": kg,

  "bloodwork.cholesterol": plain("mmol/L"),
  "bloodwork.cholesterol_hdl": plain("fraction"),
  "bloodwork.crp": plain("mg/L"),
  "bloodwork.hba1c": plain("mmol/mol"),
  "bloodwork.hdl": plain("mmol/L"),
  "bloodwork.ldl": plain("mmol/L"),
  "bloodwork.non_hdl": plain("mmol/L"),
  "bloodwork.triglycerides": plain("mmol/L"),
  "bloodwork.haemoglobin": plain("g/L"),
  "bloodwork.glucose": plain("mmol/L"),

  "bloodwork.white_blood_cells.total": plain("x10⁹/L"),
  "bloodwork.white_blood_cells.neutrophils": plain("x10⁹/L"),
  "bloodwork.white_blood_cells.basophils": plain("x10⁹/L"),
  "bloodwork.white_blood_cells.monocytes": plain("x10⁹/L"),
  "bloodwork.white_blood_cells.eosinophils": plain("x10⁹/L"),
  "bloodwork.white_blood_cells.lymphocytes": plain("x10⁹/L"),

  "cardio.align_peaks.ptt": plain("s"),
  "cardio.ankle_pressure.left": pressure,
  "cardio.ankle_pressure.right": pressure,
  "cardio.body_distance.carotis_jugulum": plain("centimeters"),
  "cardio.body_distance.jugulum_umbilicus": plain("centimeters"),
  "cardio.body_distance.umbilicus_femoralis": plain("centimeters"),
  "cardio.brachial_pressure.left": brachialPressure,
  "cardio.brachial_pressure.right": brachialPressure,
  "cardio.heart_rate": plain("bpm"),
  "cardio.oxygen_saturation": percent,
  "cardio.toe_pressure.left": pressure,
  "cardio.toe_pressure.right": pressure,

  "lifestyle.drinking-habit": drinking,
  "lifestyle.physical-activity": physicalActivity,
  "lifestyle.smoking-habit": smoking,
  "lifestyle.snus-habit": snus,

  "medical_history.family_conditions": condition,
  "medical_history.high_bloodpressure": highBloodPressure,

  "risk_assessment.familial_hypercholesterolemia": boolean,
  "risk_assessment.drug-induced_bleeding": boolean,
  "risk_assessment.ecg_discrepancy": boolean,
  "risk_assessment.congestive_heart_failure_history": boolean,
  "risk_assessment.diabetes_history": boolean,
  "risk_assessment.frax_score": plain("percent"),
  "risk_assessment.eye_pressure.left": pressure,
  "risk_assessment.eye_pressure.right": pressure,
  "risk_assessment.hypertension_history": boolean,
  "risk_assessment.kidney_disease": boolean,
  "risk_assessment.labile_inr": boolean,
  "risk_assessment.liver_disease": boolean,
  "risk_assessment.major_bleeding_history": boolean,
  "risk_assessment.stroke_history": boolean,
  "risk_assessment.thromboembolism_history": boolean,
  "risk_assessment.tia_history": boolean,
  "risk_assessment.vascular_disease_history": boolean,
};
